// extracted by mini-css-extract-plugin
export default {"toggle_btn_icon":"navbar_toggle_btn_icon__cDkBT","collapsed":"navbar_collapsed__ZBa72"};